(function() {
  'use strict';

const mediaWithText = document.querySelectorAll('media-with-text')

mediaWithText.forEach(el => {
  const quoteWrapper = el.querySelector('[data-media-quotes]');

  if (quoteWrapper) {
    let activeQuote = 0;
    const quotes = quoteWrapper.querySelectorAll('[data-quote]');

    if (quotes.length > 1) {
      setInterval(() => {
        const isLast = activeQuote === (quotes.length - 1);
        if (isLast) activeQuote = 0;
        else activeQuote++;
        quotes.forEach((quote, index) => {
          quote.classList.toggle('is-active', index === activeQuote)
        })
      }, 5000);
    }

  }
});

})();